import { render, staticRenderFns } from "./PJProposalInsuranceHistory.vue?vue&type=template&id=3c85e64e"
import script from "./PJProposalInsuranceHistory.vue?vue&type=script&lang=js"
export * from "./PJProposalInsuranceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports